import React, { useMemo, ComponentType, ReactNode } from 'react';

import { CONTEXT_NAMES } from '@adsk/alloy-helpers';
import {
  getOrCreateGlobalContext,
  useContextWithValidation,
} from '@adsk/alloy-react-context';

import { useCurrentProject } from './ProjectEntitlementsContext';

type CurrentAccountIdContextValue = {
  accountId?: string;
};

/**
 * Context for current account ID.
 */
const CurrentAccountIdContext =
  getOrCreateGlobalContext<CurrentAccountIdContextValue>(
    CONTEXT_NAMES.CurrentAccountIdContext,
  );

const useCurrentAccountIdContext = () =>
  useContextWithValidation(CurrentAccountIdContext, {
    hook: 'useCurrentAccountIdContext',
    provider: 'CurrentAccountIdProvider',
  });

export const useCurrentAccountId = () => {
  const currentAccountIdContext = useCurrentAccountIdContext();
  return currentAccountIdContext?.accountId;
};

type CurrentAccountIdProviderProps = {
  accountId?: string;
  children: ReactNode;
};

export const CurrentAccountIdProvider: ComponentType<
  CurrentAccountIdProviderProps
> = ({ children, accountId: accountIdProp }) => {
  const currentProject = useCurrentProject();
  const accountIdFromProject = currentProject?.accountId;
  const accountId = accountIdProp || accountIdFromProject;
  const value = useMemo(
    () => ({
      accountId,
    }),
    [accountId],
  );
  return (
    <CurrentAccountIdContext.Provider value={value}>
      {children}
    </CurrentAccountIdContext.Provider>
  );
};

CurrentAccountIdProvider.displayName = 'CurrentAccountIdProvider';
